import { render, staticRenderFns } from "./JSbridge.vue?vue&type=template&id=730bfb6d"
import script from "./JSbridge.vue?vue&type=script&lang=js"
export * from "./JSbridge.vue?vue&type=script&lang=js"
import style0 from "./JSbridge.vue?vue&type=style&index=0&id=730bfb6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports